import { render, staticRenderFns } from "./patientReferralDoctors.vue?vue&type=template&id=58983f68&scoped=true&v-slot%3Acontent=true&"
import script from "./patientReferralDoctors.vue?vue&type=script&lang=js&"
export * from "./patientReferralDoctors.vue?vue&type=script&lang=js&"
import style0 from "./patientReferralDoctors.vue?vue&type=style&index=0&id=58983f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58983f68",
  null
  
)

export default component.exports